


















































import Vue from 'vue'
import Component, {mixins} from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import AppRelease from '@/modules/app-router/model/AppRelease'
import {DateMixin} from '@/modules/core/date'
import DuplicateRelease from '@/modules/app-router/components/AppRelease/DuplicateRelease.vue';
@Component({
    components: {DuplicateRelease},
})
export default class AppReleaseListItem extends mixins(DateMixin) {
    /**
     * Distribución de una app
     */
    @Prop({type: AppRelease, default: () => new AppRelease()})
    public release: AppRelease

    @Prop({type: String, default: null})
    public width: string

    public duplicateRelease = false

    /**
     * Abre el dialogo para la duplicación de la distribución mostrada
     * por este elemento
     */
    public duplicate () {
        this.$store.commit('appRouter/SET_CURRENT_APP_RELEASE', this.release)
        this.duplicateRelease = true
    }
}
